<template>
  <div style="display: block;">
    <label class="app-checkbox">
      <input type="checkbox" @change="change" v-bind="$attrs" :checked="checked" />
      <span></span>
      <div v-if="label" v-html="label"></div>
    </label>
    <span class="help-block" v-if="help" v-html="help"></span>
  </div>
</template>

<script>
export default {
  props: ["value", "label", "help"],
  data() {
    return {
      checked: this.value
    };
  },
  updated() {
    this.checked = this.$props.value;
  },
  methods: {
    change() {
      this.checked = !this.checked;
      this.$emit("input", this.checked);
    }
  }
};
</script>
